export const SECTION = Object.freeze({
  HEADER: 'HEADER',
  WELCOME: 'WELCOME',
  CONCEPT: 'CONCEPT',
  COMPANY: 'COMPANY',
  CONTACT: 'CONTACT',
  FOOTER: 'FOOTER',
})
